import { render, staticRenderFns } from "./MainRoot.vue?vue&type=template&id=acc48598"
import script from "./MainRoot.vue?vue&type=script&lang=js"
export * from "./MainRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports